module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Flower#3-7a48e6ae0a7263440e29c385867a7d832668f1db946872c7cdac86b7ff87b048.svg";